import { render, staticRenderFns } from "./EnegryContact.vue?vue&type=template&id=15dc78b4&"
import script from "./EnegryContact.vue?vue&type=script&lang=ts&"
export * from "./EnegryContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports